import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import { normalizeSizeString } from 'app/util/sizes'
import classNames from 'lib/util/classNames'
import styles from './Group.module.scss'

/**
 * The `Group`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Group (props) {
  const { children, className, display, margin } = props
  const classNameOutput = useMemo(
    () =>
      classNames([
        styles.group,
        className,
        styles[`display-${display}`],
        styles[`margin-${normalizeSizeString(margin)}`]
      ]),
    [className, display, margin]
  )

  return <div className={classNameOutput}>{children}</div>
}

/** @type {object} */
Group.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  display: PropTypes.string,
  margin: PropTypes.string
}

/** @type {object} */
Group.defaultProps = {
  children: null,
  className: '',
  display: 'standard',
  margin: 'standard'
}

// Memoize
export default memo(Group)
